export const GET_SHOPPING_CART = 'GET_SHOPPING_CART';
export const REMOVE_SHOPPING_CART = 'REMOVE_SHOPPING_CART';
export const DELETE_ALL_CART_PRODUCT = 'DELETE_ALL_CART_PRODUCT';
export const SHOPPING_CART_ERROR = 'SHOPPING_CART_ERROR';
export const GET_LIST_SHOPPING_CART = 'GET_LIST_SHOPPING_CART';
export const SET_CART_LOADING = 'SET_CART_LOADING';
export const GET_SHOPPING_CART_ERROR = 'GET_SHOPPING_CART_ERROR';
export const GET_ALL_CART_EVENT = 'GET_ALL_CART_EVENT';
export const GET_ALL_CART_EVENT_SUCCESS = 'GET_ALL_CART_EVENT_SUCCESS';
